module.exports = __webpack_public_path__ + "static/media/oct30-5.42823656.png";